import { TextField } from '@mui/material';
import './PaymentsTextField.scss';

const PaymentsTextField = ({ fieldName, label, value, fieldWidth, fixedLabel, onChange, error }) => {

  const inputProps = {
    style : {
      padding: 5,
      width: fieldWidth,
    }
  };

  function fieldLabel() {
    var className = "inline-label";
    if (fixedLabel) {
      className = "inline-label payments-text-label";
    }
    // console.log("returned data: ", <div className={className}>{label}:</div>)
    return <div className={className}>{label}:</div>

  }
      
  // console.log('props - ', inputProps);

  return (
    <>
      {fieldLabel()}
      <div><TextField 
          fullWidth
          inputProps={inputProps}
          variant="outlined"
          value={value}
          size="small"
          error={error}
          helperText={error}
          onChange={(e) => {onChange(e.target.value, fieldName)}}
          />
      </div>
      <div>&nbsp;</div>
    </>
  );
}

export default PaymentsTextField;